import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationRepoDeleteArgs } from "types/generated";

export const DELETE_SPACELIFT_VCS_REPO: TypedDocumentNode<
  { repoDelete: boolean },
  MutationRepoDeleteArgs
> = gql`
  mutation DeleteSpaceliftVcsRepo($id: ID!) {
    repoDelete(id: $id)
  }
`;
